import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function getDefaultDates() {
  const end = new Date();
  end.setHours(23, 59, 59, 999);
  const start = new Date(end);
  start.setDate(end.getDate() - 1);
  start.setHours(0, 0, 0, 0);
  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
}

export function useDateRangeUrl() {
  const [params, setParams] = useSearchParams();

  const { start, end } = useMemo(() => {
    const defaults = getDefaultDates();
    return {
      start: params.get("start") || defaults.start,
      end: params.get("end") || defaults.end,
    };
  }, [params]);

  const setDateRange = (start: string, end: string) => {
    setParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("start", start);
      newParams.set("end", end);
      return newParams;
    });
  };

  return { start, end, setDateRange };
}
